<template>
	<v-app>
		<div>
			<div v-if="is_expired">
				<p class=" page-title text-center mt-10"> Link Expired </p>
			</div>
			<div>
				<v-row justify="center" class="custome-form">
					<v-col cols="12" md="3">
						<p class="sub-title-text-dark mb-5 mt-9 text-center"> {{$lang.SUMMARY}}</p>
						<v-row justify="center" class="custome-form">
							<v-col cols="6" md="6" class="py-1">
								<label class="fs-14">{{$lang.PLAN}}</label>
							</v-col>
							<v-col cols="6" md="6" class="py-1 pl-10">
								<p v-if="transaction_details" class="secondary-text">{{transaction_details.plan_name}}</p>
							</v-col>
							<v-col cols="6" md="6" class="py-1 ">
								<label class="fs-14"> {{$lang.AMOUNT}}</label>
							</v-col>
							<v-col cols="6" md="6" class="py-1 pl-10">
								<p v-if="transaction_details" class="secondary-text">{{transaction_details.amount}}</p>
							</v-col>
							<v-col cols="6" md="6" class="py-1">
								<label class="fs-14">{{$lang.NUMBER_OF_DAYS}}</label>
							</v-col>
							<v-col cols="6" md="6" class="py-1 pl-10">
								<p  class="secondary-text">{{transaction_details.plan_validity}} {{$lang.DAYS}}</p>
							</v-col>
							<v-col cols="6" md="6" class="py-1">
								<label class="fs-14">{{$lang.NUMBER_OF_SHIPMENT}}</label>
							</v-col>
							<v-col cols="6" md="6" class="py-1 pl-10">
								<p v-if="transaction_details" class="secondary-text">{{transaction_details.shipment_count}}</p>
							</v-col>
							<v-col cols="6" md="6" class="py-1">
								<label class="fs-14">{{$lang.TYPE}}</label>
							</v-col>
							<v-col cols="6" md="6" class="py-1 pl-10">
								<p v-if="transaction_details" class="secondary-text">{{transaction_details.type}}</p>
							</v-col>
							<v-col cols="6" md="6" class="py-1">
								<label class="fs-14">{{$lang.PLAN_TYPE}}</label>
							</v-col>
							<v-col cols="6" md="6" class="py-1 pl-10">
								<p v-if="transaction_details" class="secondary-text">{{transaction_details.plan_type}}</p>
							</v-col>
						</v-row>

						<form method="post" :action="paytm_url+'?mid='+paytm_mid+'&orderId='+order_id" name="paytm">
							<table border="0" class="d-none">
								<tbody>
									<input type="text" name="mid" :value="$keys.PAYTM_MID">
									<input type="text" name="orderId" :value="order_id">
									<input type="text" name="txnToken" :value="transaction_token">
								</tbody>
							</table>
							<div class="text-center">
								<v-btn  type="submit" color="primary" :loading="btn_loading" id="submitBtn" class="mt-10"  ref="submitBtn">
									<b>{{$lang.CONTINUE}}</b>
								</v-btn>
							</div>
						</form>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-app>
</template>
<script >

import { mapGetters } from 'vuex';
export default {
	data(){
		return{
			btn_loading:false,
			transaction_token:"",
			order_id:"",
			transaction_details:{},
			is_expired:false
		}
	},
	computed: mapGetters({
		paytm_mid: 'getPaytmMid',
		paytm_url: 'getPaytmUrl',
	}),
	created(){
		if (this.$route.query.order_id){
			let order_id=this.$route.query.order_id
			// this.order_id= this.decrypt(this.$route.params.order_id)
			this.initiatePayment(order_id)
		} 
	},
	methods:{
		initiatePayment(order_id){
			const self=this
			self.btn_loading=true
			var	form = new FormData();
			form.append("order_id",order_id)

			const successHandler = (response) => {
				if(response.data.success){
					if(response.data.is_expired){
						self.is_expired=response.data.is_expired
					}
					else{
						this.order_id=response.data.paytm_order_id
						this.transaction_token=response.data.transaction_token
						this.transaction_details=response.data.transaction_details
					}
				}

			};
			const finallyHandler = () => {
				self.btn_loading=false
			};
			this.request_POST(self,self.$urls.INITIATE_PAYMENT_FOR_ADDON,form,successHandler,null,null,finallyHandler)

		},
	}
}

</script>